import React, { useCallback } from 'react';
import { Card } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useToast } from 'core/components/toast';

import useSession from 'core/hooks/use-session';
import getQuoteFriendlySelectedOption from 'offer/helpers/quote-friendly-selected-option';
import { useStore } from 'core/store';
import { OfferStatus } from 'core/store/offer-store';
import { Label } from 'core/components/label';
import { types } from 'core/helpers/sanitize';
import DownloadButton from './download-button';

import useStyles from './downloads.styles';

const Downloads = observer(() => {
  const { offer: offerStore, affinityLookups } = useStore();
  const toast = useToast();
  const { offer, downloadQuote, downloadOffer, status, selectedOption } = offerStore;
  const { clusterId, code, id: offerId, quote } = offer;
  const quoteFriendlyOption = getQuoteFriendlySelectedOption(selectedOption);
  const classes = useStyles();
  const { user, isAgency } = useSession();

  const affinity = quote?.global?.affinity;
  const affinityData = affinityLookups.data.find((aff) => aff.affinity.startsWith(affinity));
  const agencyAffinity = affinity && affinityData?.isAgency;
  // if agency affinity and internal agent is binding for them, keep agency rep as sales rep
  const dontOverwriteRep = Boolean(!isAgency && agencyAffinity);

  const onDownloadQuote = useCallback(() => {
    downloadQuote({ bypassCache: false });
    toast.notify({
      type: 'success',
      message: 'PDF not correct?',
      label: 'Regenerate from scratch',
      action: () => downloadQuote({ bypassCache: true }),
      durationInSeconds: 30
    });
  }, [downloadQuote, toast]);

  const onDownlaodOffer = useCallback(() => {
    downloadOffer({
      offerId,
      clusterId,
      code,
      policyType: quoteFriendlyOption,
      bypassCache: false,
      revisedQuoteDetails: types.QuoteDetailsInput({
        ...quote,
        rep: quote?.rep?.length && dontOverwriteRep ? quote.rep : user.username
      })
    });
    // Temporarily disabled the toast notification for offer download
    /*toast.notify({
      type: 'success',
      message: 'PDF not correct?',
      label: 'Regenerate from scratch',
      action: () =>
        downloadOffer({
          offerId,
          clusterId,
          code,
          policyType: quoteFriendlyOption,
          bypassCache: true,
          revisedQuoteDetails: types.QuoteDetailsInput({
            ...quote,
            rep: quote?.rep?.length && dontOverwriteRep ? quote.rep : user.username
          })
        }),
      durationInSeconds: 30
    });*/
  }, [downloadOffer, offerId, clusterId, code, quoteFriendlyOption, toast, user, quote, dontOverwriteRep]);

  return (
    <>
      <Label variant="body3" className={classes.downloadHeader}>
        Downloads
      </Label>
      <Card className={classes.pdfDownloadContainer}>
        <DownloadButton
          loading={status === OfferStatus.DownloadingQuote}
          classes={classes}
          onClick={onDownloadQuote}
          downloadText="Application PDF"
        />
        <DownloadButton
          loading={status === OfferStatus.DownloadingOffer}
          classes={classes}
          onClick={onDownlaodOffer}
          downloadText="Offer PDF"
        />
      </Card>
    </>
  );
});

export default Downloads;
